/**
 * Tono badge per rating (SPEC-007), separato da AiAnalysisSection.tsx: un file
 * che esporta sia componenti sia costanti rompe il Fast Refresh di Vite.
 */

import type { AnalysisRating } from './ai-analysis-api';

export const RATING_TONE: Record<AnalysisRating, 'positive' | 'negative' | 'neutral'> = {
  Buy: 'positive',
  Overweight: 'positive',
  Hold: 'neutral',
  Underweight: 'negative',
  Sell: 'negative',
  // Neutro come `Hold`, ma per una ragione opposta: `Hold` è una scelta, questo
  // è l'assenza di una scelta. La distinzione la porta il testo, non il colore —
  // un colore proprio suggerirebbe una posizione intermedia che non esiste.
  Review: 'neutral',
};

/**
 * Spiegazione mostrata accanto al giudizio, dove ce n'è bisogno.
 *
 * ⚠️ È un `Record` completo con `null` sui cinque livelli, non un `Partial`:
 * così un giudizio nuovo non può essere aggiunto senza che qualcuno decida se
 * va spiegato. `Review` è l'unico che da solo non si capisce — e mostrarlo nudo
 * lascerebbe credere a un guasto invece che a un'analisi riuscita senza verdetto.
 */
export const RATING_HINT: Record<AnalysisRating, string | null> = {
  Buy: null,
  Overweight: null,
  Hold: null,
  Underweight: null,
  Sell: null,
  Review:
    "L'analisi è arrivata in fondo, ma nella decisione finale non c'era un giudizio " +
    'riconoscibile. Il report qui sotto è valido e completo; il consiglio operativo no, ' +
    "quindi questa analisi non alimenta l'auto-trading.",
};
